import React, { useEffect } from "react";
import { fetchMasterProfileList } from "../../../../../../redux/actions/resources/master/profiles/profile";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { CustomDetailsList } from "../../../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../../../common/skeleton/skeleton";
import { MasterProfileColumns } from "./column/column";

interface IMasterProfilesList {
    widthPopUp: any;
    heigthPopUp: any;
}

export const MasterProfileList: React.FC<IMasterProfilesList> = ({ heigthPopUp, widthPopUp }) => {
    const { loading, list } = useAppSelector((state) => state.masterProfileList);
    const dispatch = useAppDispatch();

    const renderColumns = () => {
        return MasterProfileColumns();
    };

    useEffect(() => {
        list === undefined && dispatch(fetchMasterProfileList());
    }, [list]);

    return loading ? (
        <Skeleton rows={5}></Skeleton>
    ) : (
        <CustomDetailsList
            data={list ?? []}
            renderColumns={renderColumns}
        />
    );
};
